<div id="error-404" fxLayout="column" fxLayoutAlign="center center">
  <div class="content" fxLayout="column" fxLayoutAlign="center center">
    <div class="error-code">
      <span>4</span>
      <img src="/assets/images/404.svg" />
      <span>4</span>
    </div>

    <div class="message">{{ 'ERROR_404.MESSAGE' | translate }}</div>

    <a class="back-link" [routerLink]="'/relatorios/manutencoes'">
      {{ 'ERROR_404.GO_TO_START' | translate }}
    </a>
  </div>
</div>
